/*
 * Search behavior.
 */
var SearchController = (function ($) {
  
  var doc, win, header, toggleSearch, searchUI, searchUIDesktop, closeButton, searchInput,
      searchUrl = "/search",
      defaultValue = "Search",
      defaultValueTest = /^\s*Search\s*$/;
  
  function ready() {
    win = $(window);
    doc = $(document.body);
    header = $('header');
    searchUI = $(".search-ui", header);
    searchUIDesktop = $("header > .search-ui");
    closeButton = $('.close', searchUIDesktop);
    searchInput = $('input[type=text]', searchUI);
    toggleSearch = $("a.toggle-search", header);
    toggleSearch.on('click', onToggleSearchClick);
    closeButton.on('click', onCloseClick);
    searchInput.on('keypress', onSearchInputKeypress);
    searchInput.on('keyup', onSearchInputKeyup);
    doc.on('click', onDocClick);
    fixGoogleSearchStyles();
  }
  
  /*
   * Apply a special class to tables within the Google search widget
   * so that they can be targeted with CSS.
   */
  function fixGoogleSearchStyles() {
    $('form.gsc-search-box').find('table').addClass('google-search');
  }
  
  function onMobileSearchInputFocus(e) {
    var clicked = $(e.target);
    if (BreakpointController.isMobile()) {
      searchInput.val('').removeClass('placeholder');
    }
  }
  
  // On document click, close the search if not a toggle or clicking somewhere within the search.
  function onDocClick(e) {
    var clicked = $(e.target);
    
    if (!(clicked.closest("a.toggle-search").length > 0 || clicked.closest('.search-ui').length > 0)) {
      close();
    }
  }
  
  // Execute a search by hitting the Search Url with the querystring parameter.
  function executeSearch(q) {
    q = "" + q;
    if (!/^\s*$/.test(q)) {
        window.location.href = searchUrl + "?ss360Query=" + encodeURIComponent(q);
    }
  }

  // If enter key is pressed, fire off the search.
  function onSearchInputKeypress(e) {
    var searchInput = $(e.target);
    switch(e.keyCode) {
      case 13:
        e.preventDefault();
        executeSearch(searchInput.val());
        break;
      case 27:
        e.preventDefault();
        close();
        break;
    }
  }
  
  function onSearchInputKeyup(e) {
    switch(e.keyCode) {
      case 27:
        e.preventDefault();
        close();
        break;
    }
  }
    
  function onCloseClick(e) {
    e.preventDefault();
    close();
  }
  
  function onToggleSearchClick(e) {
    e.preventDefault();
    if (searchUIDesktop.is(":visible")) {
      close();
    }
    else {
      open();
    }
  }
  
  // Expand the search.
  function open() {
    searchUIDesktop.slideDown(400, 'easeOutQuart', function () {
      if ($("html").hasClass("lt-ie9")) return;
      searchInput.focus();
      searchInput.val('');
    });
  }
  
  // Close the search.
  function close(clearInput) {
    clearInput = !!clearInput;
    searchUIDesktop.slideUp(400, 'easeOutQuart', function () {
      searchInput.val('');
      if ($("html").hasClass("lt-ie9")) {
        searchInput.focus();
        searchInput.blur();
      }
    });
  }
  
  // Blur the textbox so it doesn't have focus any more.
  function blur() {
    searchInput.blur();
  }
  
  // Clear the input.
  function clear() {
    searchInput.val('');
  }
  
  $(ready);
  return {
    open: open,
    close: close,
    executeSearch: executeSearch,
    blur: blur,
    clear: clear
  };
  
})(jQuery);